import { useCallback } from 'react';
import { useAppConfig } from '../../acl/acl-provider.tsx';
import { DialogStateManager } from '../../dialog/dialog-provider.tsx';
import { TaskBulkCreateDialog } from '../components/task-bulk-create-dialog.tsx';
import type { TaskCreateDialogProps } from '../components/task-create-dialog.tsx';
import { TaskCreateDialog } from '../components/task-create-dialog.tsx';

export const useShowCreateTaskDialog = (): ((props: TaskCreateDialogProps) => void) => {
    const { enableBulkTaskCreation } = useAppConfig();

    return useCallback(
        (props: TaskCreateDialogProps) => {
            void DialogStateManager.show(
                enableBulkTaskCreation ? TaskBulkCreateDialog : TaskCreateDialog,
                props,
            );
        },
        [enableBulkTaskCreation],
    );
};
